import clsx from 'clsx'

const StepProgressBar = ({ currentStep, stepLabel = '', steps }) => {
  const dividers = Array(steps).fill(undefined)

  return (
    <div className='relative flex w-3/4 flex-row md:w-[630px]'>
      <div className={`relative z-[1] flex w-full flex-row ${steps === 1 ? 'justify-center' : 'justify-between'}`}>
        {dividers.map((_, step) => (
          <span className='relative flex flex-col items-center pb-11' key={step}>
            <div
              className={clsx(
                'bg-background-default flex h-8 w-8 items-center justify-center rounded-full border-2 text-center text-sm leading-none',
                currentStep < step && 'bg-background-default text-text-alternative',
                currentStep === step && 'border-primary-default text-primary-default',
                currentStep > step && 'border-primary-default bg-primary-default text-primary-inverse'
              )}
            >
              <span className='m-auto'>{step + 1}</span>
            </div>
            <span
              className={`absolute left-0 top-[40px] -ml-[40px] line-clamp-2 w-[100px] text-sm font-medium md:-ml-[78px]  md:w-[180px] ${
                currentStep === step ? 'text-primary-default opacity-100' : 'opacity-0'
              }`}
            >
              {stepLabel}
            </span>
          </span>
        ))}
      </div>
      <div className='absolute left-0 right-0 top-3 m-auto flex w-full flex-row flex-nowrap'>
        {dividers.slice(1).map((_, step) => (
          <div
            className={clsx(
              'b-8  flex-grow border-0 border-t-2',
              ` ${step < currentStep ? 'border-error' : ''}`,
              currentStep > step && 'border-primary-default'
            )}
            key={step}
          />
        ))}
      </div>
    </div>
  )
}

export default StepProgressBar
